import { Input as InputPrimitive } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import React from "react";

export const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input">
>(({ className, type, ...props }, ref) => {
  return (
    <InputPrimitive
      type={type}
      className={cn(
        "h-11 rounded-xl border-none bg-[#1C1C1E] px-4 py-3",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
